import { ISmbNode } from '../model/types'

/**
 * A row that carries no split at all: its category is Not applicable in Planning, or the row
 * itself is reported as disabled. Such a row shows a single message instead of the grid, keeps
 * its own product tree hidden, and stays out of every roll-up, seed and saved payload - it must
 * never make an otherwise complete parent look unplanned.
 */
export const isSmbNodeExcluded = (node: ISmbNode): boolean =>
  node.isNotApplicable || node.isDisabled
